var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden p-3 text-center bg-white border-15 shadow"},[_c('i',{staticClass:"fa fa-spinner fa-pulse text-success mt-3",staticStyle:{"font-size":"100px"}}),_c('h2',{staticClass:"text-center bMikhak p-3 mt-3 text-orange"},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }